/* global __CLIENT__ */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import exact from 'prop-types-exact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-regular-svg-icons';
import A1GA from '../../helpers/A1GA';
import {
    playLive, playMediaPlayer, pauseMediaPlayer,
} from '../../components/aovivoBar/actions/MediaPlayerActions';
import Placeholder from '../placeholder/Placeholder';
import Button from '../button/Button';

let playerjs;

if (__CLIENT__) {
    // eslint-disable-next-line global-require
    playerjs = require('player.js');
}

// TODO: Think about multiples podcasts player on the same page: stop others if a new one is started

class EmbededPodcast extends Component {
    constructor(props) {
        super(props);

        this.state = {
            playerStatus: null,
            podcastPlaying: false,
            showLoadButton: this.props.showLoadButton,
            loading: true, // to avoid confusion when switching between episodes or shows!
            loadingTime: 700,
        };

        this._addPlayerJs = this._addPlayerJs.bind(this);

        this.player = false;

        this.playerHeights = {
            mini: 52,
            standard: 200,
            show: 480,
        };

        this.checkBlockHandle = false;

        setTimeout(() => this.setState({ loading: false }), this.state.loadingTime);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.podcastType !== nextProps.podcastType ||
            this.props.podcastId !== nextProps.podcastId ||
            this.props.playerStatus !== nextProps.playerStatus ||
            this.state.showLoadButton !== nextState.showLoadButton ||
            this.state.loading !== nextState.loading;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.playerStatus !== this.props.playerStatus && this.props.playerStatus === 'playing') {
            // stream started, try to stop podcast
            // note: this seams to be working just fine but the embeded players play button is not updated
            if (this.player && this.state.podcastPlaying) {
                this.player.pause();
            }
        }

        if (prevProps.podcastType !== this.props.podcastType) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ loading: true });

            setTimeout(() => this.setState({ loading: false }), this.state.loadingTime);
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.pause();

            this.player.off('ready');

            this.player.off('play');

            this.player.off('pause');

            this.player.off('ended');

            this.player = undefined;
        }

        clearTimeout(this.checkBlockHandle);
    }

    // We are doing this to log if the player is blocked by CSP
    // or if there is another error which does not load the player
    _checkIfBlocked = () => {
        this.checkBlockHandle = setTimeout(() => {
            if (!this.player.isReady) {
                A1GA.event({
                    category: 'Podcasts',
                    action: 'podcast_not_loaded',
                    label: this.props.podcastType,
                    nonInteraction: true,
                });
            }
        }, 7000);
    }

    _loadPodcast = (e) => {
        e.preventDefault();

        e.stopPropagation();

        if (!this.props.podcastId && this.props.episodeLink) {
            // this is a PRO podcast, send the user to the single podcast page
            return this.props.history.push(this.props.episodeLink);
        }

        return this.setState({
            showLoadButton: false,
        });
    }

    _addPlayerJs(e) {
        this._checkIfBlocked();

        this.player = new playerjs.Player(e.target);

        this.player.on('ready', () => {
            if (this.props.showLoadButton) {
                this.player.play();
            }

            this.player.on('play', () => {
                this.setState({
                    podcastPlaying: true,
                    playerStatus: this.props.playerStatus,
                });

                this.props.pauseMediaPlayer();
            });

            /* removed as it might be anoying...
            this.player.on('pause', () => {
                this.setState({
                    podcastPlaying: false
                })
                if(this.state.playerStatus){
                    // TODO: if we need this one more time, create a 'continuePlayback' function in the mediaplayer actions that will do the following verification
                    if(this.props.isLive === true){
                        this.props.playLive();
                    }else{
                        this.props.playMediaPlayer()
                    }
                }
            }); */

            // if the stream was playing when the podcast was started, continue playback when the podcast ended
            this.player.on('ended', () => {
                this.setState({
                    podcastPlaying: false,
                });

                if (this.state.playerStatus === 'playing') {
                    // TODO: if we need this one more time, create a 'continuePlayback' function in the mediaplayer actions that will do the following verification
                    if (this.props.isLive === true) {
                        this.props.playLive();
                    } else {
                        this.props.playMediaPlayer();
                    }
                }
            });

            // not working
            // this.player.getDuration(duration => console.log("duration", duration));

            // not working
            // if (this.player.supports('method', 'mute')) {
            //    //player.mute();
            // }
        });
    }

    render() {
        const height = this.playerHeights[this.props.playerType];

        const style = this.props.isShow ? '?dark=false&show=true' : `${this.props.playerStyle}`; // can be null
        const loadPodcastButtonStyle = {
            color: this.props.playerColor,
            borderColor: this.props.playerColor,
            borderTop: 'none',
        };

        // alternative players
        // <iframe onLoad={this._addPlayerJs} width="100%" height="188px" frameBorder="no" scrolling="no" src="https://play.pod.co/antena1-10mais/teste-3" />, // style={{border:none, overflow:hidden, height:188,maxWidth:750}}
        // <iframe onLoad={this._addPlayerJs} width="100%" height="200px" frameBorder="0" scrolling="no" src="https://www.buzzsprout.com/396133/1304065-teste-1?client_source=small_player&amp;iframe=true&amp;referrer=https://www.buzzsprout.com/396133.js?player=small&limit=5&artist=Antena%201" />

        if (this.state.showLoadButton) {
            return (
                <Button title="ouça agora" className="loadPodcastButton" onClick={this._loadPodcast} style={loadPodcastButtonStyle}>
                    <FontAwesomeIcon icon={faPlayCircle} size="lg" style={{ marginRight: 5 }} />
                    OUÇA AGORA
                </Button>
            );
        }

        return (
            <div>
                {
                    this.state.loading ?
                        <Placeholder width="100%" minHeight={`${height}px`} />
                        :
                        <iframe title={`${this.props.podcastType}  ${this.props.podcastId}`} allow="autoplay" onLoad={this._addPlayerJs} width="100%" height={height} style={{ backgroundColor: '#F5F5F5' }} frameBorder="no" scrolling="no" seamless src={`https://player.simplecast.com/${this.props.podcastId}${style}`} />
                }
            </div>
        );
    }
}


EmbededPodcast.propTypes = exact({
    podcastId: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.string,
    ]).isRequired,
    podcastType: PropTypes.string,
    playerType: PropTypes.string,
    playerStyle: PropTypes.string,
    playerColor: PropTypes.string,
    showLoadButton: PropTypes.bool,
    isShow: PropTypes.bool,
    playerStatus: PropTypes.string,
    pauseMediaPlayer: PropTypes.func,
    playMediaPlayer: PropTypes.func,
    playLive: PropTypes.func,
    isLive: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    episodeLink: PropTypes.string,
    history: PropTypes.object.isRequired,
    /* eslint-disable react/no-unused-prop-types */
    // Injected through withRouter but not used
    location: PropTypes.object,
    match: PropTypes.object,
    staticContext: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */

});

EmbededPodcast.defaultProps = {
    playerType: 'standard',
    podcastType: 'default', // podcastType can be null and thus the default value will not be used!
};


const mapStateToProps = (state) => ({
    playerStatus: state.aovivoBar.MediaPlayer.playerStatus,
    isLive: state.aovivoBar.MediaPlayer.isLive,
});

const mapDispatchToProps = (dispatch) => ({
    playLive: () => {
        dispatch(playLive());
    },
    playMediaPlayer: () => {
        dispatch(playMediaPlayer());
    },
    pauseMediaPlayer: () => {
        dispatch(pauseMediaPlayer());
    },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EmbededPodcast));
